import React from 'react';
import { useDarkMode } from 'hooks/useDarkMode';
import { FaMoon, FaSun } from 'react-icons/fa';

export const DarkModeToggle = () => {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <button
      onClick={toggleDarkMode}
      className="flex items-center justify-center gap-2 p-2 bg-white/10 hover:bg-white/20 rounded-full backdrop-blur-sm transition"
    >
      {isDarkMode ? <FaSun size={16} /> : <FaMoon size={16} />}
    </button>
  );
};
